import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Botao } from '../../../components/Botao';
import { CartaoDeInformacao } from '../../../components/CartaoDeInformacao';
import { CorpoDaPagina } from '../../../components/CorpoDaPagina';
import { Icone } from '../../../components/Icone';
import { EmailStore } from '../../../stores/EmailStore';
import { ContainerCard, Conteiner, ConteinerBotao } from './styles';

function ListagemInstituicao() {
  const [instituicoes, atribuirInstituicoes] = useState([]);
  const [possuiPendecia, atribuirPossuiPendencia] = useState(false);

  const historico = useHistory();

  const obterInstituicoes = async () => {
    const response = await EmailStore.obterInstituicoesPorUsuario();

    if (response.status === 200) {
      atribuirInstituicoes(response.data);
    } else if (response.status >= 400 && response.status < 500) toast.error(response.data.mensagem);
    else toast.error(response.data.message);
  };
  const verificarSePossuiPendencias = () => {
    EmailStore.verificaPossuiPendencia().then((response) => {
      if (response.status === 200) {
        atribuirPossuiPendencia(response.data);
      }
    });
  };

  useEffect(() => {
    obterInstituicoes();
    verificarSePossuiPendencias();
  }, []);

  return (
    <CorpoDaPagina titulo='Instituições vinculadas'>
      {possuiPendecia ? (
        <CartaoDeInformacao
          texto={
            'As instituições abaixo precisam do ajuste do envio de e-mail institucional. Por favor, insira o e-mail para cada instituição, somente após a adição do e-mail em todas as opções você conseguirá retornar com o acesso normal ao sistema.'
          }
          tipo={'alerta'}
        />
      ) : (
        <ConteinerBotao>
          <Botao
            texto={'Ir para solicitações'}
            aoClicar={() => historico.push('/solicitacoes')}
            cor='MEDIUM'
          >
            <Icone nome='FaWpforms' tamanho={16} />
          </Botao>
        </ConteinerBotao>
      )}

      <Conteiner>
        {instituicoes.map((instituicao) => {
          return (
            <ContainerCard
              key={instituicao.instituicaoEnsinoId}
              cor={instituicao.status === 'E-mail reprovado' ? 'DANGER' : 'BACKGROUND'}
            >
              <p>Instituição</p>
              <span>{instituicao.instituicaoEnsinoNome}</span>
              <p>Situação</p>
              <span>{instituicao.status}</span>
              <p>E-mail</p>
              <span>{instituicao.email ? instituicao.email : 'Não informado'}</span>

              {instituicao.status === 'E-mail reprovado' ? (
                <Botao
                  texto={'Editar e-mail'}
                  aoClicar={() =>
                    historico.push(`/email/editar/${instituicao.instituicaoEnsinoId}`)
                  }
                  cor='danger'
                >
                  <Icone nome='FaPen' tamanho={16} />
                </Botao>
              ) : (
                <Botao
                  texto={
                    instituicao.status === 'E-mail aprovado' ? 'Editar e-mail' : 'Adicionar e-mail'
                  }
                  aoClicar={() =>
                    instituicao.status === 'E-mail aprovado'
                      ? historico.push(`/email/editar/${instituicao.instituicaoEnsinoId}`)
                      : historico.push(`/email/novo/${instituicao.instituicaoEnsinoId}`)
                  }
                  desabilitado={instituicao.status === 'Aguardando análise'}
                  outlined={instituicao.status === 'E-mail aprovado'}
                >
                  {instituicao.status === 'E-mail aprovado' ? (
                    <Icone nome='FaPen' tamanho={16} />
                  ) : (
                    <Icone nome='FaPlus' tamanho={16} />
                  )}
                </Botao>
              )}
            </ContainerCard>
          );
        })}
      </Conteiner>
    </CorpoDaPagina>
  );
}

export default ListagemInstituicao;
